import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Container, Button, FormGroup, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, isNull, upperCase } from "lodash";
import Spinner from 'react-bootstrap/Spinner';
import MaterialTable from 'material-table';
import 'jspdf-autotable';
import Select from 'react-select';
import Swal from 'sweetalert';
import { UpdateHREmployeeType, deleteHREmployeeType, getHREmployeeType } from "./HRDetails.actions";
import { baseURL, headers } from "../../../../../global/api";


const EmployeeTypeList = (props) => {
    const tableRef = useRef();
    function updateTableQuery() {
      tableRef.current.onQueryChange()
    };
    const employeeTypeData = isEmpty(props.employeeTypeList) ? [] : props.employeeTypeList.reverse();
    console.log('employeeTypeData', employeeTypeData);
  
    useEffect(() => {
        props.getHREmployeeType();
    }, []);
    return (
        <>
            {(props.isFetchingEmployeeTypeData ) ? (
                <div className="loader-div">
                    <Button variant="info" disabled>
                        <Spinner
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            variant="info"
                        />
                        {/* {props.isFetchingwareHouseList ? 'Loading...' : 'Loading...'} */}

                    </Button>
                </div>
            ) : (
                <Container fluid>

                            <Form>
                            <MaterialTable
                            title="EmployeeType"
                            columns={[
                                { title: 'EmployeeType Name', field: 'employeeType' },
                                { title: 'EmployeeType Description', field: 'description' },
                            ]}
                            // data={employeeTypeData}
                            data={(query) =>
                                new Promise((resolve, reject) => {
                                  let url = `${baseURL}/employeeType?`;
                                  url += "limit=" + query.pageSize;
                                  url += "&page=" + query.page;
                                  url += "&search=" + query.search;
                                  fetch(url, {
                                    method: "GET",
                                    headers: headers,
                                  })
                                    .then((response) => response.json())
                                    .then((result) => {
                                      resolve({
                                        data: result.data,
                                        page: result.page,
                                        totalCount: result.total_results,
                                      });
                                    });
                                })
                              }
                              options={{
                                actionsColumnIndex: -1,
                                filtering: false,
                                exportButton: true,
                                exportAllData: true,
                                sorting: true,
                                paging: true,
                                pageSize: 50, // make initial page size
                                emptyRowsWhenPaging: false, // To avoid of having empty rows
                                pageSizeOptions: [50, 100, 150, 200,500], // rows selection options
                                headerStyle: {
                                    position: 'sticky', top: 0,
                                    color: '#00BBBB',
                                    fontWeight: '550',
                                    onRowAdd: 'none',
                                },

                            }}
                            editable={{
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            {
                                                // console.log('newData', newData),
                                                props.UpdateHREmployeeType(newData, oldData,updateTableQuery)
                                            }
                                        }, 600);
                                    }),
                                onRowDelete: (oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            props.deleteHREmployeeType(oldData._id,updateTableQuery);
                                            console.log(oldData, 'old')
                                        }, 600);
                                    }),
                            }}
                        />
                            </Form>


                </Container>

            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        getHREmployeeType: () => dispatch(getHREmployeeType()),
        UpdateHREmployeeType: (newData, oldData,updateTableQuery) => dispatch(UpdateHREmployeeType(newData, oldData,updateTableQuery)),
        deleteHREmployeeType: (employee_type_id,updateTableQuery) => dispatch(deleteHREmployeeType(employee_type_id,updateTableQuery)),
    };
};
const mapStateToProps = (state, ownProps) => ({
        employeeTypeList: state.HrReducer.employeeTypeList,
        isFetchingEmployeeTypeData: state.HrReducer.isFetchingEmployeeTypeData,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmployeeTypeList);